import { useEffect, useState } from 'react';

import { TableCell } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface CheckboxCellProps {
  row: GenericObject;
  column: ColumnInterface;
}

export const CheckboxCell = ({ row, column }: CheckboxCellProps) => {
  const [checked, setChecked] = useState(column?.isPublished ? !!column?.isPublished(row) : false);

  useEffect(() => {
    setChecked(column?.isPublished ? !!column?.isPublished(row) : false);
  }, [column, row]);

  const toggleCheckbox = async () => {
    column.toggleCheckbox && column.toggleCheckbox(row, !checked);
  };

  return (
    <TableCell align="left">
      <Checkbox checked={checked} onChange={toggleCheckbox} inputProps={{ 'aria-label': 'checked' }} />
    </TableCell>
  );
};
